import React from 'react';
import { Routes, Route, Link, Router,Navigate } from 'react-router-dom';
import logo from '../Assets/InsuranceExchange_logo.svg';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import AuthUser from '../AuthUser';
import Dashboard from '../Pages/Dashboard'
import Profile from '../Pages/Profile';
import Changepassword from '../Pages/Changepassword';
import Messages from '../Pages/Messages';
import Notifications from '../Pages/Notifications';
import BrowsingHistory from '../Pages/BrowsingHistory';
import Appointments from '../Pages/Appointments/Appointments';
import Requestacall from '../Pages/Requestacall/Requestacall';
import Agents from '../Pages/UserManagement/Agents';
import Customers from '../Pages/UserManagement/Customers';
import Staff from '../Pages/UserManagement/Staff';
import Insurancecarriers from '../Pages/UserManagement/Insurancecarriers';
import QuotesforIndividual from '../Pages/RFQ/QuotesforIndividual';
import QuotesforBusiness from '../Pages/RFQ/QuotesforBusiness';
import QuotesforAnnuity from '../Pages/RFQ/QuotesforAnnuity';
import ApprovedPolicySubmissions from '../Pages/PolicyManagement/ApprovedPolicySubmissions';
import RejectPolicySubmissions from '../Pages/PolicyManagement/RejectPolicySubmissions';
import ModifyPolicySubmissions from '../Pages/PolicyManagement/ModifyPolicySubmissions';
import RenewalsandCancellationspolicies from '../Pages/PolicyManagement/RenewalsandCancellationspolicies';
import CustomersInsights from '../Pages/DataInsightsandReports/CustomersInsights';
import AgentsInsights from '../Pages/DataInsightsandReports/AgentsInsights';

function AdminNav() {
    const { token, logout, getUser } = AuthUser();
    let userdetails = getUser();
    let loguser = userdetails.first_name + " " + userdetails.last_name;
    const logoutUser = () => {
        if (token !== undefined) {
            logout();
        }
    }
    const isAuthenticated = (userdetails !== '') ? true : false;
    return (
        <div >
            <nav class="navbar navbar-expand-lg border-bottom shadow-sm" style={{ backgroundColor: "#ffffff" }}>
                <div class="container-fluid">
                    <Navbar.Brand as={Link} to="/"><img src={logo} alt='Employment Exchange' className='img-fluid logo' style={{ width: 320 }} /></Navbar.Brand>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">

                        <Form className="me-auto my-2 my-lg-0">
                            <Form.Control
                                type="search"
                                placeholder="Search "
                                className="me-2 search rounded-0"
                                aria-label="Search"
                            />

                        </Form>
                        <ul class="navbar-nav ms-md-auto gap-2 list-group-horizontal">
                            <li class="nav-item rounded">
                                <ul class="notification-drop">
                                    <li class="item">
                                        <Nav.Link as={Link} to="/Messages"> <i class="bi bi-chat-left-fill"></i></Nav.Link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item rounded">
                                <ul class="notification-drop">
                                    <li class="item">
                                        <Nav.Link > <i class="bi bi-bell-fill"></i></Nav.Link>
                                        <ul className='shadow'>

                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown  pt-2 ml-2" style={{ borderLeft: '1px solid #D5D5D5' }}>
                                <Nav.Link class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-caret-down-fill"></i></Nav.Link>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <Dropdown.Item><span className='fw-bold'>User Name</span></Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/Profile">My Profile</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/Changepassword">Change Password  </Dropdown.Item>
                                    <hr></hr>
                                    <Dropdown.Item onClick={logoutUser}>Logout</Dropdown.Item>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <Routes>                
                <Route path="/" element={<Dashboard />} />
                <Route path="/Profile" element={<Profile />} />
                <Route path="/Changepassword" element={<Changepassword />} />
                <Route path="/Messages" element={<Messages />} />
                <Route path="/Notifications" element={<Notifications />} />
                <Route path="/BrowsingHistory" element={<BrowsingHistory />} />
                <Route path="/Appointments" element={<Appointments />} />
                <Route path="/Requestacall" element={<Requestacall />} />
                <Route path="/Agents" element={<Agents />} />
                <Route path="/Customers" element={<Customers />} />
                <Route path="/Staff" element={<Staff />} />
                <Route path="/Insurancecarriers" element={<Insurancecarriers />} />
                <Route path="/QuotesforIndividual" element={<QuotesforIndividual />} />
                <Route path="/QuotesforBusiness" element={<QuotesforBusiness />} />
                <Route path="/QuotesforAnnuity" element={<QuotesforAnnuity />} />
                <Route path="/ApprovedPolicySubmissions" element={<ApprovedPolicySubmissions />} />
                <Route path="/RejectPolicySubmissions" element={<RejectPolicySubmissions />} />
                <Route path="/ModifyPolicySubmissions" element={<ModifyPolicySubmissions />} />
                <Route path="/RenewalsandCancellationspolicies" element={<RenewalsandCancellationspolicies />} />
                <Route path="/CustomersInsights" element={<CustomersInsights />} />
                <Route path="/AgentsInsights" element={<AgentsInsights />} />
            </Routes>
        </div>
    )
}

export default AdminNav